import styled from "styled-components/macro";

const FieldLabel = styled.label`
  font-size: 14px;
  margin-bottom: 8px;
`;

export default FieldLabel;
